const createTheme = (theme) => {
  return theme;
};
export {
  createTheme
};
//# sourceMappingURL=createTheme.js.map
